module.exports = {
  FIREBASE_VAPIKEY:
    "BOYcxVyNU2OxLcr8wpJZMJPQYt8kyHQVztZa-HaDVH9J5Ju3RJObD7B0GG8nMJGKLMoIfa0uRU2ZMjmOr9Dmrxs",
};
